{
  "statusPill": {
    "new": "Nouveau",
    "planning": "Planification",
    "dataPrep": "Préparation des données",
    "reportGen": "Génération du rapport",
    "complete": "Terminé",
    "archived": "Archivé"
  },
  "planItemEditor": {
    "edit": "Modifier",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "saving": "Enregistrement…",
    "title": "Titre",
    "description": "Description",
    "method": "Méthode",
    "expectedOutput": "Résultat attendu",
    "required": "Ce champ ne peut pas être vide.",
    "readTitle": "Titre",
    "readDescription": "Ce que cela couvre",
    "readMethod": "Comment",
    "readExpectedOutput": "Résultat attendu"
  },
  "acceptGap": {
    "modal": {
      "title": "Accepter la section comme un manque de données",
      "body": "Accepter cette section comme un manque et la verrouiller. Si la section contient déjà du contenu, le rapport le conserve et le marque « Accepté — Non réconcilié ». Si elle n'en contient aucun, le rapport affiche « Accepté — Aucun contenu » à sa place. Fournissez une brève raison pour que les relecteurs comprennent pourquoi la section n'a pas pu être terminée.",
      "placeholder": "Pourquoi cette section est-elle acceptée comme un manque ?",
      "cancel": "Annuler",
      "confirm": "Accepter comme manque",
      "submitting": "Acceptation…"
    }
  },
  "list": {
    "title": "Espaces de travail",
    "empty": "Aucun espace de travail pour le moment",
    "emptyHint": "Créez votre premier espace de travail pour commencer.",
    "loading": "Chargement des espaces de travail...",
    "loadFailed": "Échec du chargement des espaces de travail. Veuillez actualiser la page.",
    "createButton": "Créer un espace de travail",
    "search": "Rechercher des espaces de travail",
    "searchPlaceholder": "Rechercher des projets…",
    "lastModified": "Dernière modification",
    "createdAt": "Créé le {{date}}",
    "deleteConfirmTitle": "Supprimer l'espace de travail ?",
    "deleteConfirmBody": "Cela supprimera définitivement l'espace de travail, ses fichiers, son plan et tout contenu généré. Cette action est irréversible.",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "welcome": "Bon retour !",
    "welcomeSubtitle": "Commencez un nouveau projet ou reprenez là où vous vous étiez arrêté.",
    "yourProjectsTab": "Vos projets",
    "loadingProjects": "Chargement des projets...",
    "projectsHeading": "Vos projets",
    "projectsCount_one": "{{count}} projet",
    "projectsCount_other": "{{count}} projets",
    "noProjects": "Vos projets apparaîtront ici une fois que vous en aurez créé un.",
    "viewLabel": "Afficher",
    "editLabel": "Modifier",
    "archiveLabel": "Archiver",
    "ariaView": "afficher {{name}}",
    "ariaEdit": "modifier {{name}}",
    "ariaArchive": "archiver {{name}}",
    "projectsCount": "{{count}} projets"
  },
  "create": {
    "title": "Créer un espace de travail",
    "namePlaceholder": "Saisissez un nom de projet descriptif",
    "nameLabel": "Nom du projet",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Décrivez l'objectif et le périmètre de ce projet",
    "verticalLabel": "Verticale",
    "serviceTypeLabel": "Type de service",
    "outputLanguage": "Langue du rapport",
    "outputLanguageHint": "Les rapports générés seront rédigés dans cette langue. Ce choix ne peut pas être modifié après la création.",
    "strictness": "Sévérité des observations",
    "strictnessLenient": "Souple",
    "strictnessBalanced": "Équilibré (recommandé)",
    "strictnessStrict": "Strict",
    "strictnessHint": "À quel point les observations sont signalées. Souple = uniquement les écarts matériels pour le verdict réglementaire. Strict = chaque déviation distincte, y compris la présentation et la traçabilité. Équilibré est la valeur par défaut. Ne peut pas être modifié après la création.",
    "aggregation": "Agrégation des problèmes",
    "aggregationConsolidated": "Consolidé",
    "aggregationBalanced": "Équilibré (recommandé)",
    "aggregationGranular": "Granulaire",
    "aggregationHint": "Comment les observations sont regroupées dans le journal des problèmes. Consolidé = moins de problèmes racines, plus larges. Granulaire = chaque observation distincte comme un problème distinct. Équilibré est la valeur par défaut. Ne peut pas être modifié après la création.",
    "submit": "Créer",
    "cancel": "Annuler",
    "creating": "Création...",
    "errorGeneric": "Impossible de créer l'espace de travail.",
    "errorTimedOut": "L’opération a pris trop de temps. Le projet n’a peut-être pas été créé — rouvrez la liste des projets pour vérifier avant de réessayer.",
    "nameRequired": "Le nom de l'espace de travail est obligatoire.",
    "newProjectTitle": "Créer un nouveau projet",
    "newProjectSubtitle": "Donnez un nom et une description à votre projet pour commencer.",
    "editProjectTitle": "Modifier le projet",
    "editProjectSubtitle": "Mettez à jour les détails de votre projet ci-dessous.",
    "selectedWorkType": "Type de travail sélectionné",
    "createButton": "Créer le projet",
    "saveChanges": "Enregistrer les modifications",
    "newProject": "+ Nouveau projet",
    "inheritedFrom": "Hérité de",
    "scopeLabel": "Périmètre",
    "landingNote": "Vous arriverez dans l'espace de travail du projet"
  },
  "archive": {
    "title": "Archiver le projet ?",
    "body": "Cela archivera <strong>{{name}}</strong> et le retirera de vos projets actifs. Vous pourrez le restaurer plus tard depuis les archives.",
    "cancel": "Annuler",
    "confirm": "Archiver"
  },
  "card": {
    "openButton": "Ouvrir",
    "deleteButton": "Supprimer",
    "renameButton": "Renommer",
    "duplicateButton": "Dupliquer",
    "stageLabel": "Étape",
    "filesLabel": "Fichiers",
    "filesCount_one": "{{count}} fichier",
    "filesCount_other": "{{count}} fichiers"
  },
  "files": {
    "referencesPartiallyMapped": "Références partiellement mappées — réessai au prochain changement.",
    "referencesOverCap": "La cartographie des relations entre fichiers n'est pas disponible pour cet espace de travail : il est trop volumineux à cartographier (jusqu'à 200 fichiers sources sont cartographiés). Vos fichiers restent entièrement indexés et consultables.",
    "title": "Fichiers",
    "panelTitle": "Source de données",
    "viewFileMetadataTooltip": "Voir les métadonnées du fichier",
    "ariaViewFileMetadata": "Voir les métadonnées du fichier",
    "ariaRetryProcessing": "Réessayer le traitement du fichier",
    "ariaRemoveFile": "Retirer le fichier",
    "empty": "Aucun fichier importé pour le moment",
    "emptyHint": "Déposez des fichiers ici ou cliquez pour parcourir.",
    "uploadButton": "Importer des fichiers",
    "browseButton": "Parcourir",
    "dropHere": "Déposez les fichiers à importer",
    "dropHint": "PDF, DOCX, XLSX, CSV, TXT, MD, images",
    "uploading": "Importation...",
    "uploadFailed": "Échec de l'importation",
    "uploadSuccess": "Importation terminée",
    "deleteFile": "Supprimer le fichier",
    "deleteFileConfirm": "Supprimer {{name}} ?",
    "deleteFileConfirmBody": "Ce fichier sera retiré de l'espace de travail.",
    "openFile": "Ouvrir",
    "downloadFile": "Télécharger",
    "renameFile": "Renommer",
    "metadataButton": "Métadonnées",
    "reviewMetadataButton": "Examiner les métadonnées",
    "extractedFiles": "Fichiers extraits",
    "filesUploaded_one": "{{count}} fichier importé",
    "filesUploaded_other": "{{count}} fichiers importés",
    "fileTooLarge": "Fichier trop volumineux (max. {{max}}).",
    "unsupportedType": "Type de fichier non pris en charge.",
    "selectFiles": "Sélectionner des fichiers",
    "fileName": "Nom du fichier",
    "fileSize": "Taille",
    "fileType": "Type",
    "fileStatus": "Statut",
    "fileActions": "Actions",
    "category": "Catégorie",
    "uncategorized": "Non catégorisé",
    "uploadProgress": "{{name}} ({{percent}} %)",
    "approveFiles": "Approuver les fichiers",
    "approveAndContinue": "Approuver et continuer",
    "approving": "Approbation...",
    "rejectFile": "Rejeter",
    "approveFile": "Approuver",
    "fileMissingMetadata": "Métadonnées manquantes",
    "fileNeedsAttention": "Nécessite une attention",
    "fileReady": "Prêt",
    "fileEnriching": "Enrichissement..."
  },
  "metadata": {
    "title": "Métadonnées du fichier",
    "reviewTitle": "Examiner les métadonnées du fichier",
    "reviewSubtitle": "Confirmez les métadonnées détectées automatiquement pour chaque fichier avant de continuer.",
    "categoryLabel": "Catégorie",
    "sourceLabel": "Source",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Que contient ce fichier ?",
    "keyTopicsLabel": "Sujets clés",
    "tagsLabel": "Étiquettes",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "approveAll": "Tout approuver",
    "approveAllAndContinue": "Tout approuver et continuer",
    "needsReview": "Nécessite une revue",
    "approved": "Approuvé",
    "approvedCount": "{{approved}} sur {{total}} approuvés",
    "saving": "Enregistrement...",
    "saveFailed": "Impossible d'enregistrer les métadonnées.",
    "noFiles": "Aucun fichier à examiner.",
    "fileTypeLabel": "Type de fichier",
    "dataTypeLabel": "Type de données",
    "coversSectionsLabel": "Sections couvertes",
    "loadingMetadata": "Chargement des métadonnées...",
    "notRecorded": "— non renseigné",
    "extractedFromTitle": "Extrait de ce fichier",
    "selectAll": "Tout sélectionner",
    "clearSelection": "Effacer la sélection",
    "filesSelected_one": "{{count}} fichier sélectionné",
    "filesSelected_other": "{{count}} fichiers sélectionnés",
    "fields": {
      "documentRole": "Rôle du document",
      "documentRoleHelp": "Quel rôle joue ce document ?",
      "contentDescription": "Description du contenu",
      "dataType": "Type de données",
      "contentCategory": "Catégorie de contenu",
      "keyTopics": "Sujets clés",
      "relevantSections": "Sections pertinentes",
      "dataFormat": "Format des données"
    },
    "fieldLabels": {
      "content_description": "Description du contenu",
      "data_type": "Type de données",
      "document_role": "Rôle du document",
      "source_type": "Type de source",
      "author_or_source": "Auteur / Source",
      "reporting_period": "Période de reporting",
      "document_version": "Version du document",
      "key_topics": "Sujets clés",
      "regulatory_frameworks": "Cadres réglementaires",
      "user_description": "Description utilisateur",
      "content_category": "Catégorie de contenu",
      "data_format": "Format des données",
      "has_tables": "Contient des tableaux",
      "is_prior_period": "Période antérieure",
      "source_sections": "Sections sources",
      "upload_source": "Source de téléversement",
      "row_count": "Lignes",
      "column_names": "Colonnes",
      "classification_kind": "Format détecté"
    },
    "fieldDescriptions": {
      "source_sections": "Liste des identifiants de section du rapport source d'origine",
      "target_template_section_ids": "Liste des identifiants de section du modèle auxquels ce fichier correspond",
      "data_requirements_matched": "Liste des exigences de données que ce fichier satisfait",
      "key_topics": "Sujets et entités clés trouvés dans le fichier",
      "has_tables": "Indique si le fichier contient des données tabulaires",
      "table_count": "Nombre de tableaux trouvés",
      "author_or_source": "Auteur, équipe ou système/fournisseur d'origine",
      "source_type": "Classification de l'origine du fichier",
      "reporting_period": "La période de reporting couverte par le fichier",
      "is_prior_period": "Indique si le fichier contient des données d'une période antérieure",
      "document_version": "Identifiant de version du document",
      "regulatory_frameworks": "Cadres réglementaires applicables",
      "upload_source": "Comment ce fichier a été intégré à l'espace de travail",
      "content_description": "Brève description du contenu de ce fichier",
      "data_type": "Le type de données contenues dans le fichier",
      "document_role": "Le rôle de ce fichier dans vos rapports",
      "user_description": "Votre propre description du fichier",
      "content_category": "La catégorie du contenu du fichier",
      "data_format": "Le format dans lequel les données sont stockées",
      "row_count": "Nombre de lignes du fichier",
      "column_names": "Noms des colonnes du fichier",
      "classification_kind": "Comment le contenu du fichier a été classé"
    },
    "enumValues": {
      "upload_source": {
        "user_upload": "Téléversement utilisateur",
        "user_upload_sas": "Téléversement utilisateur (gros fichier)",
        "toolbox_extractor_import": "Boîte à outils : import Extractor",
        "toolbox_gatekeeper_import": "Boîte à outils : import Gatekeeper",
        "toolbox_reggie_import": "Boîte à outils : import du banc d'essai"
      },
      "document_role": {
        "model_documentation": "Documentation du modèle",
        "regulatory_framework": "Cadre réglementaire",
        "test_data": "Données de test",
        "test_results": "Résultats de test",
        "historical_report": "Rapport historique",
        "supplementary": "Document complémentaire",
        "code_artifact": "Artéfact de code"
      },
      "data_type": {
        "unstructured": "Non structuré",
        "structured": "Structuré",
        "image": "Image"
      },
      "source_type": {
        "internal_report": "Rapport interne",
        "regulatory_document": "Document réglementaire",
        "vendor_material": "Matériel fournisseur",
        "model_documentation_package": "Dossier de documentation du modèle",
        "data_file": "Fichier de données",
        "other": "Autre"
      },
      "file_format": {
        "pdf": "PDF",
        "docx": "Document Word",
        "xlsx": "Tableur Excel",
        "csv": "CSV",
        "txt": "Texte",
        "other": "Autre"
      },
      "section_type": {
        "report": "Rapport",
        "test_run": "Exécution de test",
        "table": "Tableau",
        "verbatim": "Texte intégral"
      }
    }
  },
  "tasks": {
    "descriptionLabel": "Description de la tâche",
    "descriptionPlaceholder": "Décrivez ce que vous souhaitez produire.",
    "saveTaskButton": "Enregistrer la tâche",
    "saved": "Enregistré",
    "saving": "Enregistrement...",
    "saveFailed": "Impossible d'enregistrer la tâche.",
    "templateLabel": "Modèle de sortie",
    "templatePlaceholder": "Facultatif : collez un modèle ou un plan d'exemple.",
    "saveTemplateButton": "Enregistrer le modèle",
    "uploadTemplateButton": "Importer un modèle",
    "removeTemplateButton": "Retirer le modèle"
  },
  "uploadFlow": {
    "step": {
      "upload": "Importation",
      "metadataReview": "Examen des métadonnées",
      "confirm": "Confirmer et ingérer"
    }
  },
  "evidenceMap": {
    "title": "Carte des preuves",
    "subtitle": "Tracez chaque section du plan jusqu'aux fichiers sources qui la soutiennent.",
    "noEvidence": "Aucune preuve disponible pour le moment.",
    "loading": "Chargement de la carte des preuves...",
    "close": "Fermer",
    "viewSource": "Voir la source",
    "section": "Section",
    "sources": "Sources",
    "coverage": "Couverture"
  },
  "references": {
    "panelTitle": "Références",
    "ariaLabel": "Références",
    "ariaCollapse": "Réduire les références",
    "ariaExpand": "Développer les références",
    "loading": "Chargement des références…",
    "rebuilding": "Les références sont en cours de reconstruction suite à une modification du corps du rapport.",
    "retry": "Réessayer",
    "ariaViewMetadata": "Voir les métadonnées pour {{filename}}",
    "dialogTitle": "Référence [{{number}}]",
    "ariaCloseDialog": "Fermer les détails de la référence",
    "documentRoleLabel": "Rôle du document",
    "dataTypeLabel": "Type de données"
  },
  "header": {
    "back": "Retour",
    "settings": "Paramètres",
    "exportReport": "Exporter le rapport",
    "exporting": "Export en cours...",
    "exportFailed": "Échec de l'export."
  },
  "page": {
    "ariaCollapseSidebar": "Réduire le panneau plan et données",
    "ariaExpandSidebar": "Développer le panneau plan et données",
    "loadFailed": "Échec du chargement des informations de l'espace de travail.",
    "hydrateLoading": "Chargement du projet",
    "hydrateStillWorking": "Toujours en cours…",
    "hydrateTimedOut": "Ce projet n’a pas pu être ouvert pour le moment. Rien n’a été chargé, donc rien de ce qui serait affiché ici ne serait complet.",
    "hydrateRetry": "Réessayer",
    "notFound": "Espace de travail introuvable. Redirection vers la liste des projets.",
    "filesLoadFailed": "Échec du chargement des fichiers de l'espace de travail.",
    "sectionsLoadFailed": "Échec du chargement des sections.",
    "haltCannotClear": "Impossible de lever la suspension : le plan n'est pas chargé. Rechargez l'espace de travail.",
    "testRunCancelled": "Exécution de test annulée. Vous pouvez la relancer ou passer à la génération du rapport.",
    "testRunCompleted": "Exécution de test terminée. Examinez les résultats pour continuer.",
    "testRunErrored": "Exécution de test terminée avec des erreurs. Examinez les résultats pour plus de détails.",
    "sourceUploadFailed": "Échec de l'importation du fichier source. Veuillez réessayer.",
    "sourceUploadPartialFailed": "{{uploaded}} fichier(s) sur {{total}} importé(s). Échec pour {{failed}} : {{names}}. Veuillez réessayer les fichiers en échec.",
    "sourceUploadSizeLimitHint": "{{count}} ont dépassé une limite de taille du serveur d'importation — essayez de scinder le fichier ou contactez l'assistance.",
    "metadataEnrichmentFailed": "Échec de l'enrichissement des métadonnées. Veuillez réessayer.",
    "taskUploadFailed": "Échec de l'importation de la description de tâche. Veuillez réessayer.",
    "templateUploadFailed": "Échec de l'importation du modèle de sortie. Veuillez réessayer.",
    "taskDeleteFailed": "Échec de la suppression de la description de tâche. Veuillez réessayer.",
    "templateDeleteFailed": "Échec de la suppression du modèle de sortie. Veuillez réessayer.",
    "mdrPromotionFailed": "Le rapport de développement du modèle n'a pas pu être ajouté à l'ensemble des sources. Veuillez le réimporter en tant que fichier source.",
    "planGenTimeout": "Délai dépassé pour la génération du plan. Veuillez réessayer.",
    "enrichmentPartialWarning": "Certaines sections n'ont pas pu être entièrement enrichies ({{enrichedCount}}/{{total}} entièrement enrichies). La génération du rapport se poursuivra avec les détails disponibles.",
    "planApprovalFailed": "Échec de l'approbation du plan. Veuillez réessayer.",
    "planFeedbackFailed": "Échec de la mise à jour du retour sur le plan. Veuillez réessayer.",
    "planRefreshFailed": "Le plan ne reflète peut-être pas les dernières modifications. Essayez d'actualiser.",
    "reportGenFailed": "Échec de la génération du rapport. Veuillez réessayer.",
    "progressTrackingError": "Erreur de suivi de progression. Veuillez réessayer.",
    "deleteFilesFailed_one": "Échec de la suppression de {{count}} fichier. {{detail}}",
    "deleteFilesFailed_other": "Échec de la suppression de {{count}} fichiers. {{detail}}",
    "haltDefaultMessage": "La génération de section est suspendue par un problème en amont. Levez la suspension et réessayez pour reprendre.",
    "haltDefaultPrompt": "La génération de section est suspendue.",
    "testRunInProgress": "Exécution de test en cours",
    "executingTestGroup": "Exécution du groupe de test {{current}}/{{total}}",
    "executingTestGroupNamed": "Exécution du groupe de test {{current}}/{{total}} : {{name}}",
    "executingTestGroups": "Exécution des groupes de test...",
    "cancelling": "Annulation...",
    "cancelTestRun": "Annuler l'exécution de test",
    "exportSuccess": "Rapport exporté avec succès.",
    "noSectionsToExport": "Aucune section à exporter. Générez d'abord des sections.",
    "exportFailedRetry": "Échec de l'export. Veuillez réessayer.",
    "exportFailedTitle": "Impossible de télécharger votre rapport",
    "exportTimedOut": "La préparation de votre rapport a pris trop de temps, nous avons donc arrêté d'attendre. Rien n'a été modifié — sélectionnez Télécharger pour réessayer.",
    "cannotExportSections_one": "Export impossible : {{count}} section n'est pas prête à être exportée",
    "cannotExportSections_other": "Export impossible : {{count}} sections ne sont pas prêtes à être exportées",
    "noSectionsToExportShort": "Aucune section à exporter",
    "sectionsNotReady": "Sections non prêtes :",
    "regenerateOrWait": "Régénérez les sections en échec ou attendez la fin des générations en cours avant d'exporter.",
    "exportBlockedGeneratingTitle": "Des sections sont encore en cours de génération",
    "sectionsStillGenerating": "En cours de génération :",
    "waitForGenerationToFinish": "Le téléchargement redeviendra disponible dès que ces sections seront terminées.",
    "ariaDismissExportError": "ignorer l'erreur d'export",
    "exportBlockedInProgress": "Export bloqué : certaines sections sont encore en cours de génération. Attendez la fin.",
    "dataGapSuffix_one": " ({{count}} section contient des lacunes de données : {{names}}. Vérifiez les marqueurs [DATA GAP] dans le document.)",
    "dataGapSuffix_other": " ({{count}} sections contiennent des lacunes de données : {{names}}. Vérifiez les marqueurs [DATA GAP] dans le document.)",
    "etlTimeout": "Le traitement prend plus de temps que prévu. L'ingestion des données est peut-être encore en cours.",
    "etlFailedFiles": "Échec de l'ingestion — {{count}} fichier(s) ont rencontré des erreurs. Relancez l'ingestion de l'espace de travail.",
    "cannotExportSections": "Impossible d'exporter — aucune section auto-vérifiée.",
    "dataGapSuffix": " — {{count}} section(s) signalée(s) comme lacunes de données : {{names}}",
    "deleteFilesFailed": "Échec de la suppression de {{count}} fichier(s)",
    "holisticPausedAlert_one": "L'auto-vérification globale est en pause — <strong>{{count}} section</strong> doit encore être résolue pour que le rapport puisse aboutir. Cliquez sur <strong>{{retryAction}}</strong> sur chaque section en échec (ou utilisez <strong>{{bulkAction}}</strong> en bas du rapport) pour réessayer. Si une section ne peut pas être récupérée, cliquez sur <strong>{{acceptGapAction}}</strong> sur cette section pour livrer le rapport malgré tout : une section qui a déjà du contenu le conserve, marqué « Accepté — Non réconcilié », et une section sans contenu affiche « Accepté — Aucun contenu » à sa place.",
    "holisticPausedAlert_other": "L'auto-vérification globale est en pause — <strong>{{count}} sections</strong> doivent encore être résolues pour que le rapport puisse aboutir. Cliquez sur <strong>{{retryAction}}</strong> sur chaque section en échec (ou utilisez <strong>{{bulkAction}}</strong> en bas du rapport) pour réessayer. Si une section ne peut pas être récupérée, cliquez sur <strong>{{acceptGapAction}}</strong> sur cette section pour livrer le rapport malgré tout : une section qui a déjà du contenu le conserve, marqué « Accepté — Non réconcilié », et une section sans contenu affiche « Accepté — Aucun contenu » à sa place.",
    "chatError": {
      "agent_timeout": "L'assistant a mis trop de temps à répondre. Veuillez réessayer.",
      "agent_crash": "L'assistant a rencontré une erreur. Veuillez réessayer.",
      "tool_call_failed": "Une action d'outil a rencontré une erreur. Veuillez réessayer.",
      "retrieval_miss": "Aucune information pertinente n'a été trouvée dans votre espace de travail.",
      "context_overflow": "La conversation est trop longue. Veuillez démarrer une nouvelle discussion.",
      "concierge_classify_error": "Je n'ai pas compris votre demande. Veuillez la reformuler et réessayer.",
      "workflow_state_guard": "Cette action n'est pas autorisée à l'étape actuelle de votre espace de travail.",
      "validation_error": "Votre requête contient des champs invalides. Veuillez vérifier et réessayer.",
      "not_found": "L'espace de travail ou le plan est introuvable.",
      "unauthorized": "Vous n'avez pas accès à cette ressource.",
      "provider_error": "Le fournisseur d'IA est indisponible pour le moment. Veuillez réessayer dans un instant.",
      "plan_revision_unmatched_sections": "Je n'ai pas pu appliquer cette modification, car elle faisait référence à des sections absentes de votre plan. Votre plan n'a pas été modifié : veuillez réessayer en nommant les sections à modifier.",
      "plan_revision_unmatched_sections_de_checklist": "Je n’ai pas pu appliquer cette modification, car elle faisait référence à des éléments absents de votre liste de contrôle de l’efficacité de la conception. Rien n’a été modifié. Veuillez préciser les éléments à modifier et réessayer.",
      "plan_revision_unmatched_sections_oe_checklist": "Je n’ai pas pu appliquer cette modification, car elle faisait référence à des éléments absents de votre liste de contrôle de l’efficacité opérationnelle. Rien n’a été modifié. Veuillez préciser les éléments à modifier et réessayer.",
      "plan_revision_duplicate_sections": "Je n'ai pas pu appliquer cette modification, car elle nommait la même section plusieurs fois. Votre plan n'a pas été modifié : veuillez réessayer.",
      "plan_revision_integrity_failed": "La révision a échoué aux contrôles d’intégrité du plan. Votre plan est inchangé. Veuillez préciser les modifications souhaitées.",
      "plan_revision_saved_response_failed": "Votre révision a été enregistrée, mais sa confirmation a échoué. Vérifiez le plan enregistré avant de demander une autre modification.",
      "ingest_in_progress": "De nouveaux éléments probants sont en cours d'ajout à cet espace de travail. Veuillez réessayer une fois leur ingestion terminée.",
      "audit_gate_unavailable": "Impossible de vérifier si de nouveaux éléments probants sont en cours d'ajout. Veuillez réessayer dans un instant.",
      "plan_already_approved": "Ce plan a été approuvé et est verrouillé : il ne peut plus être modifié.",
      "plan_already_approved_report": "Le plan du rapport a été approuvé et est verrouillé : il ne peut plus être modifié.",
      "plan_already_approved_de_checklist": "La liste de contrôle de conception effective a été approuvée et est verrouillée : elle ne peut plus être modifiée.",
      "plan_already_approved_oe_checklist": "La liste de contrôle de fonctionnement effectif a été approuvée et est verrouillée : elle ne peut plus être modifiée.",
      "plan_version_conflict": "Ce plan a été modifié depuis votre dernier affichage : rien n'a été changé. La dernière version est maintenant affichée ; vérifiez-la, puis renvoyez votre demande.",
      "plan_version_conflict_report": "Le plan du rapport a été modifié depuis votre dernier affichage : rien n'a été changé. La dernière version est maintenant affichée ; vérifiez-la, puis renvoyez votre demande.",
      "plan_version_conflict_de_checklist": "La liste de contrôle de conception effective a été modifiée depuis votre dernier affichage : rien n'a été changé. La dernière version est maintenant affichée ; vérifiez-la, puis renvoyez votre demande.",
      "plan_version_conflict_oe_checklist": "La liste de contrôle de fonctionnement effectif a été modifiée depuis votre dernier affichage : rien n'a été changé. La dernière version est maintenant affichée ; vérifiez-la, puis renvoyez votre demande.",
      "workspace_terminal": "Ce projet est terminé et en lecture seule : il ne peut plus être révisé. Vous pouvez toujours poser des questions à son sujet.",
      "workspace_archived": "Cet espace de travail a été archivé et est en lecture seule : il ne peut plus être révisé.",
      "workspace_model_archived": "Le modèle auquel appartient cet espace de travail a été archivé ; l'espace de travail est en lecture seule et ne peut plus être révisé.",
      "workspace_deleting": "Cet espace de travail est en cours de suppression ; il ne peut plus être modifié.",
      "content_filtered": "L'assistant a refusé de répondre à cette demande.",
      "unknown": "Une erreur inattendue s'est produite. Veuillez réessayer.",
      "run_item_regen_disabled": "Les résultats de conception effective et de fonctionnement effectif ne peuvent pas être régénérés élément par élément. Pour les modifier, mettez à jour les éléments probants et relancez toute la phase."
    },
    "planGenError": {
      "plan_template_status_persist_failed": "La génération du plan n'a pas pu enregistrer l'état de mise en forme de votre modèle. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_block_labels_missing": "La génération du plan n'a pas pu déterminer quelles pages du modèle font partie du rapport. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_block_labels_invalid": "La génération du plan n'a pas pu déterminer quelles pages du modèle font partie du rapport. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_block_labels_unknown_id": "La génération du plan a fait référence à des pages qui n'existent pas dans votre modèle. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "plan_structure_non_content_blocks_present": "La génération du plan a renvoyé une structure inattendue. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_block_labelling_timeout": "La lecture des pages de votre modèle a pris trop de temps. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_block_labelling_failed": "La génération du plan n'a pas pu lire les pages de votre modèle. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_label_contract_violation": "Votre modèle n'a pas pu être préparé pour la planification. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_constraint_invalid": "Votre modèle n'a pas pu être préparé pour la planification. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "constraint_extraction_failed": "La génération du plan n'a pas pu lire les contraintes de votre description de tâche. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "constraint_extraction_timeout": "La lecture des contraintes de votre description de tâche a pris trop de temps. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "mdr_extract_failed": "Le rapport de développement du modèle de ce projet n'a pas pu être lu. Veuillez le téléverser à nouveau et l'approuver de nouveau (PDF ou DOCX), puis réessayer.",
      "audit_scope_extract_failed": "L'un des documents de périmètre de ce projet n'a pas pu être lu. Veuillez le téléverser à nouveau (PDF, DOCX, Markdown ou TXT), puis réessayer.",
      "plan_structure_max_rounds": "La génération du plan n'a pas pu terminer la structure du plan. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "plan_structure_orphaned": "La génération du plan a produit des sous-sections sans leur titre parent. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "enrichment_timeout": "La génération du plan a pris trop de temps pour détailler les sections. Veuillez relancer la génération du plan.",
      "enrichment_below_threshold": "La génération du plan n'a pas pu détailler suffisamment de sections. Veuillez relancer la génération du plan.",
      "plan_template_labels_persist_failed": "La génération du plan n'a pas pu enregistrer la mise en page de votre modèle. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "plan_template_outline_invalid": "Nous n'avons pas pu préparer votre modèle pour la planification. Veuillez le réexporter depuis Microsoft Word, le téléverser à nouveau et réessayer.",
      "template_cleanup_contract_violation": "Votre modèle n'a pas pu être préparé à partir de ce plan. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "plan_template_drift": "La génération du plan a omis des sections exigées par votre modèle. Aucun plan n'a été enregistré. Veuillez réessayer.",
      "template_parse_failed": "Nous n'avons pas pu lire votre modèle. Veuillez le réexporter depuis Microsoft Word et le téléverser à nouveau.",
      "missing_task_description": "Une description de la tâche est requise avant de générer un plan. Veuillez en téléverser une, puis réessayer.",
      "plan_structure_timeout": "L'étape de structure du plan a mis trop de temps à répondre. Veuillez réessayer.",
      "plan_structure_unparseable": "L'étape de structure du plan n'a pas renvoyé de résultats exploitables. Veuillez réessayer.",
      "plan_merge_drift": "L'enrichissement du plan a produit des résultats incohérents. Veuillez réessayer.",
      "no_sections_generated": "La génération du plan n'a produit aucune section après plusieurs tentatives. Veuillez réessayer.",
      "plan_persist_failed": "La génération du plan est terminée mais n'a pas pu être enregistrée. Veuillez réessayer.",
      "plan_gen_unhandled": "La génération du plan a rencontré une erreur inattendue. Veuillez réessayer.",
      "recoveredFailed": "La génération du plan a échoué. Veuillez réessayer ou contacter le support.",
      "unknown": "La génération du plan a échoué. Veuillez réessayer.",
      "plan_gen_in_progress": "Un plan est déjà en cours de génération pour cet espace de travail. Veuillez attendre la fin de l'opération.",
      "plan_already_exists": "Un plan existe déjà pour cet espace de travail. Supprimez-le ou modifiez-le avant d'en générer un nouveau.",
      "enrichment_rate_limited": "L'enrichissement du plan a été limité par le débit et n'a pas pu aboutir après plusieurs tentatives. Veuillez relancer la génération du plan."
    },
    "etlFailedWorkspace": "L’ingestion a échoué avant de pouvoir se terminer. Aucun fichier n’a signalé d’erreur individuellement. Relancez l’ingestion de l’espace de travail.",
    "useAsMdrAction": "Utiliser pour le modèle",
    "useAsMdrConfirmTitle": "Utiliser ce rapport comme rapport de développement du modèle",
    "useAsMdrConfirmBody": "Ce rapport sera ajouté au modèle comme nouvelle version de son rapport de développement, en attente d'approbation. Tant que quelqu'un ne l'aura pas approuvé sur la page d'aperçu du modèle, la génération du plan l'utilise comme référence provisoire non approuvée. Rien n'est remplacé et rien n'est supprimé — si ce n'est pas le bon rapport, retirez la version à cet endroit pour la mettre hors service.",
    "useAsMdrConfirmAction": "Ajouter au modèle",
    "useAsMdrSubmitting": "Ajout en cours…",
    "useAsMdrUnconfirmed": "Ce rapport a été envoyé au modèle, mais il n'apparaît pas encore sur la page d'aperçu du modèle. Vérifiez-y avant de l'ajouter à nouveau.",
    "useAsMdrFailed": "Ce rapport n'a pas pu être ajouté au modèle. Veuillez réessayer.",
    "haltClearAndRetry": "Lever la pause et réessayer"
  },
  "cards": {
    "retryFromScratch": "Réessayer depuis le début",
    "retrying": "Nouvelle tentative…",
    "feedback": "Commentaire",
    "acceptAsGap": "Accepter comme lacune",
    "unreconciledGapTitle": "Accepté — Non réconcilié",
    "unreconciledGapBody": "Le validateur du rapport a demandé une révision de cette section. La révision n'a pas abouti et le relecteur a accepté l'écart. Le contenu ci-dessous est le texte d'origine, non révisé.",
    "generationFailed": "Échec de la génération.",
    "contextDegraded": "Une partie des documents de référence n'a pas pu être utilisée lors de la rédaction de cette section ; elle peut donc être incomplète. Régénérez la section pour réessayer.",
    "figuresNotShown": "Les figures de cette section n'ont pas été montrées au modèle qui l'a rédigée ; le texte peut donc ne pas s'y référer. Régénérez la section avec un modèle capable de voir les figures pour les inclure.",
    "generationFailedTransient": "Échec de la génération en raison d'un problème temporaire du fournisseur. Veuillez patienter un instant puis réessayer.",
    "generationFailedHelper": "Échec de la génération. Cliquez sur « Réessayer depuis le début » pour régénérer cette section.",
    "bulkRegenInProgressTooltip": "Une régénération groupée est en cours — attendez qu'elle se termine avant de relancer une section individuelle.",
    "retryInProgressTooltip": "Une nouvelle tentative est déjà en cours pour cette section.",
    "uploadSourceFiles": "Importer les fichiers sources",
    "dropUnreadable": "Ce glisser-déposer n'a pas pu être lu. Utilisez plutôt le bouton Fichiers ou Dossier.",
    "uploadingFile": "Importation du fichier...",
    "uploadingFiles": "Importation de {{count}} fichiers...",
    "cancelUpload": "Annuler",
    "filesButton": "Fichiers",
    "folderButton": "Dossier",
    "uploadTip": "Astuce : organisez les fichiers en dossiers (par ex. <1>developer/</1>, <2>validator/</2>). Jusqu’à 200 fichiers sources par espace de travail. Les archives .zip et .egp sont décompressées automatiquement — ajoutez-les avec le bouton Fichiers ou par glisser-déposer.",
    "uploadedFilesHeader": "Fichiers importés",
    "fileRemovedLabel": "Retiré",
    "attentionEnrichmentIncomplete": "Attention — Enrichissement incomplet",
    "deleteFolderTitle": "Supprimer le dossier ?",
    "deleteFolderBody_one": "Cela supprimera définitivement <1>{{count}}</1> fichier sous",
    "deleteFolderBody_other": "Cela supprimera définitivement <1>{{count}}</1> fichiers sous",
    "deleteFolderHint": "Les fichiers et tout ce qui en a été indexé sont supprimés. La complétude sera réévaluée par la suite.",
    "deleteFolderConfirm_one": "Supprimer {{count}} fichier",
    "deleteFolderConfirm_other": "Supprimer {{count}} fichiers",
    "deletingProgress": "Suppression…",
    "ariaDeleteFolder": "Supprimer {{count}} fichiers dans {{name}}",
    "testOutputTooltip": "Sortie de test",
    "autoAddedReference": "Référence ajoutée automatiquement",
    "autoAddedReferenceWithStatus": "Référence ajoutée automatiquement · {{status}}",
    "statusReady": "Prêt",
    "statusReadyLayoutWarning": "Prêt, mais une partie de la mise en forme n’a pas pu être lue",
    "statusProcessing": "Traitement",
    "statusIngestedAssessmentPending": "Ingéré — évaluation en attente",
    "statusAwaitingProcessing": "En attente de traitement",
    "statusNeedsReview": "Nécessite une revue",
    "statusIndexingFailed": "Échec de l'indexation",
    "statusExtractionFailed": "Échec de l'extraction",
    "statusFailed": "Échec",
    "statusDeletionIncomplete": "Suppression incomplète",
    "statusUnknown": "Inconnu",
    "rejectedUnsupportedContent": "Non ajouté — ce type de fichier n’est pas pris en charge, ou le fichier n’est pas un texte lisible",
    "rejectedDefault": "Impossible à ajouter",
    "uploadedDate": "Importé le {{date}}",
    "uploadedJustNow": "Importé à l'instant",
    "clickToBrowse": "Cliquez pour parcourir ou faites glisser-déposer",
    "clickBrowseOrDrop": "Cliquez pour parcourir ou faites glisser-déposer",
    "dragDropOrButtons": "Glissez-déposez ou utilisez les boutons ci-dessus",
    "supportedFileTypesLabel": "Pris en charge : PDF, DOCX, PPTX, XLSX, XLS, CSV, MD, TXT, RST, IPYNB, JSON, NDJSON, Parquet, images, et fichiers source/config en texte brut (PY, R, SQL, JS, TS, HTML, CSS, SH, YAML, TOML, INI, LOG, XML, etc.)",
    "planGenSupportedFileTypesLabel": "Pris en charge : .docx, .pdf, .md, .markdown, .txt",
    "unsupportedPlanGenFile": "Les fichiers {{ext}} ne sont pas pris en charge ici — importez un fichier .docx, .pdf, .md, .markdown ou .txt.",
    "uploadTaskDescriptionLabel": "Importer la description de tâche",
    "uploadOutputTemplateLabel": "Importer le modèle de sortie",
    "taskDescriptionTitle": "Description de la tâche",
    "taskDescriptionHelp": "Incluez les exigences détaillées du projet : objectifs globaux, contraintes et règles de conformité, directives d'utilisation des données, standards de sortie attendus, et toute autre information pertinente.",
    "outputTemplateTitle": "Modèle de sortie",
    "outputTemplateHelp": "Vous pouvez fournir un modèle ou un rapport existant pour guider la structure des sections. S'il est omis, la structure du plan sera dérivée de la description de la tâche et des connaissances du domaine.",
    "outputTemplateOptional": "(facultatif)",
    "generatePlan": "Générer le plan",
    "generatingPlan": "Génération du plan…",
    "planReadyCelebrationTitle": "Plan prêt !",
    "planReadyCelebrationSubtitle": "Votre plan d'exécution est terminé",
    "regenerateAllFailed": "Régénérer tous les échecs",
    "regenerating": "Régénération…",
    "bulkRegenStarted": "Régénération de {{n}} sections",
    "bulkRegenAlready": "Régénération de {{n}} sections déjà en cours",
    "bulkRegenNone": "Aucune section en échec à régénérer",
    "regenAlreadyRunning": "Une régénération est déjà en cours pour cet espace de travail. Elle se terminera en arrière-plan — inutile de cliquer à nouveau.",
    "regenAlreadyRunningTooltip": "Une régénération est déjà en cours pour cet espace de travail — attendez qu'elle se termine avant de relancer cette section.",
    "generationStillRunningTooltip": "La génération est toujours en cours.",
    "feedbackRegenRunningTooltip": "Cette section est en cours de régénération. Attendez qu'elle se termine avant d'envoyer un nouveau retour.",
    "singleRetryTooltip": "Une nouvelle tentative de section unique est en cours — attendez qu'elle se termine avant de régénérer tous les échecs.",
    "exportTooltipInProgress": "Export en cours…",
    "exportTooltipNeedsSections": "Générez d'abord les sections du rapport",
    "exportTooltipNeedsValidated": "Au moins une section doit atteindre l'état auto-vérifié (lancez l'auto-vérification globale ou acceptez tel quel) avant que le téléchargement soit disponible",
    "exportTooltipSectionGenerating": "Une section est en cours de régénération — le téléchargement redeviendra disponible une fois terminée",
    "ariaSourceReference": "Référence source",
    "ariaFindingNavigate": "Aller à {{findingId}} dans la section d'origine",
    "ariaImageUnavailable": "Échec de l'extraction de l'image — image indisponible",
    "badgeImageUnavailable": "⚠ Image indisponible — échec de l'extraction",
    "sectionPhase": {
      "extractingSymptoms": "En attente de compilation des problèmes",
      "aggregatingIssues": "Préparation du journal des problèmes",
      "holisticValidating": "Auto-vérification…",
      "execSumGenerating": "Génération du résumé exécutif…"
    },
    "unsupportedFormatSkipped": "Format non pris en charge ignoré : {{names}}",
    "approvedLabel": "Approuvé",
    "approvingLabel": "Approbation…",
    "approvePlanLabel": "Approuver le plan",
    "previousPlanLabel": "Plan précédent",
    "supersededChip": "remplacé",
    "noItemsInPlan": "Aucun élément dans le plan",
    "generatedExecutionPlan": "Plan d'exécution généré",
    "planSummary_one": "J'ai généré un plan avec {{count}} élément basé sur vos documents.",
    "planSummary_other": "J'ai généré un plan avec {{count}} éléments basé sur vos documents.",
    "requirementsLabel": "Exigences",
    "expectedOutputLabel": "Sortie attendue",
    "methodLabel": "Méthode",
    "testRunChip": "Exécution de test",
    "testRunBlurb": "Cette section génère des données de test pour l'auto-vérification — elle ne produit pas de contenu de rapport.",
    "untitledItem": "(Sans titre)",
    "execSummaryBlocked": "résumé exécutif bloqué",
    "execSummaryWaiting_one": " — en attente de {{count}} section",
    "execSummaryWaiting_other": " — en attente de {{count}} sections",
    "execSummaryBlockedDefault": "Le résumé exécutif est bloqué jusqu'à ce que toutes les sections du corps atteignent l'état auto-vérifié.",
    "execSummaryBlockedTooltip_one": "Bloqué par {{count}} section : {{detail}}",
    "execSummaryBlockedTooltip_other": "Bloqué par {{count}} sections : {{detail}}",
    "figureCaption": "Figure du document source",
    "deleteFolderConfirm": "Supprimer {{count}} fichier(s) ?",
    "execSummaryBlockedTooltip": "Le résumé exécutif ne peut pas encore être généré — terminez d'abord les autres sections.",
    "execSummaryWaiting": "En attente des sections dépendantes...",
    "planSummary": "Résumé du plan",
    "reportGenerated": "Rapport rédigé",
    "testRunInProgress": "Exécution de test en cours...",
    "waitingForDataCheck": "En attente de la vérification des données...",
    "mappingDocRelationships": "Cartographie des relations entre documents...",
    "loadingMethodologyContext": "Chargement du contexte méthodologique...",
    "preparingAnalysis": "Préparation de l'analyse...",
    "analyzingDataCoverage": "Analyse de la couverture des données...",
    "finalizingReport": "Finalisation du rapport...",
    "checkingData": "Vérification des données...",
    "uploadsPausedPipeline": "Les téléversements sont suspendus le temps que vos fichiers finissent d'être traités.",
    "reviewEvidenceAndGenerate": "Examiner les preuves et rédiger le rapport",
    "preparingYourReport": "Rédaction de votre rapport",
    "download": "Télécharger",
    "planGen": {
      "buildingBlueprint": "Construction du plan d'exécution",
      "phase": {
        "enriching": {
          "label": "Lecture des sources",
          "description": "Lecture des fichiers importés pour en extraire la structure, le contexte et les références."
        },
        "verifying_plan": {
          "label": "Vérification de l'alignement du plan",
          "description": "Recoupement du plan du rapport avec les lacunes de couverture détectées."
        },
        "preparing_template": {
          "label": "Mise en forme du modèle",
          "description": "Nettoyage du modèle, mappage des emplacements et préparation des styles."
        },
        "finalizing_template": {
          "label": "Enregistrement du modèle",
          "description": "Persistance du modèle nettoyé pour la génération du rapport."
        },
        "finalizing": {
          "label": "Finalisation",
          "description": "Génération de chaque section et finalisation du corps du rapport."
        }
      }
    },
    "archiveError": {
      "bad_archive": "Impossible d’ouvrir « {{archive}} » — le fichier est peut-être endommagé ou n’est pas une archive. Rien n’a été ajouté.",
      "empty_archive": "« {{archive}} » ne contient aucun fichier exploitable. Rien n’a été ajouté.",
      "archive_too_large": "« {{archive}} » est trop volumineux pour être décompressé dans le navigateur (limite : {{limitMb}} Mo). Décompressez-le localement puis importez le dossier.",
      "too_many_members": "« {{archive}} » contient {{entries}} fichiers et cet espace de travail en compte déjà {{existing}} — la limite est de {{limit}} fichiers sources. Rien n’a été ajouté.",
      "zip_slip": "« {{archive}} » contient un chemin de fichier non sécurisé et n’a pas été décompressé. Rien n’a été ajouté.",
      "symlink_entry": "« {{archive}} » contient un lien symbolique, qui ne peut pas être traité. Rien n’a été ajouté.",
      "encrypted_archive": "« {{archive}} » est protégé par mot de passe. Retirez le mot de passe et réessayez.",
      "unsupported_compression": "« {{archive}} » utilise un format de compression illisible. Enregistrez-le au format zip standard et réessayez.",
      "nested_archive": "« {{archive}} » contient une autre archive (« {{entry}} »). Décompressez-la d’abord, puis importez. Rien n’a été ajouté.",
      "duplicate_entry": "« {{archive}} » contient des chemins de fichiers en double et n’a pas été décompressé. Rien n’a été ajouté.",
      "entry_too_large": "« {{archive}} » contient un fichier de plus de {{limitMb}} Mo. Rien n’a été ajouté.",
      "compression_ratio": "« {{archive}} » contient un fichier dont la taille décompressée est anormalement grande ; il n’a pas été décompressé. Rien n’a été ajouté.",
      "unsupported_browser": "Votre navigateur ne peut pas décompresser les archives. Décompressez « {{archive}} » localement puis importez le dossier.",
      "egp_missing_manifest": "« {{archive}} » ne contient pas son fichier de projet SAS Enterprise Guide (project.xml) et n’a pas pu être décompressée. Rien n’a été ajouté.",
      "egp_bad_manifest": "Le fichier de projet SAS Enterprise Guide de « {{archive}} » n’a pas pu être lu. Rien n’a été ajouté.",
      "egp_unmapped_member": "« {{archive}} » contient un programme (« {{entry}} ») que son fichier de projet SAS Enterprise Guide ne décrit pas. Rien n’a été ajouté."
    },
    "uploadTip_auditing": "Astuce : organisez les pièces justificatives de l’audit dans des dossiers par phase ou par contrôle. Jusqu’à 200 fichiers sources par espace de travail. Les archives .zip et .egp sont décompressées automatiquement — ajoutez-les avec le bouton Fichiers ou par glisser-déposer.",
    "unreconciledGapBody_auditing": "Une révision de cette section d’audit a été demandée, mais n’a pas été effectuée. Le réviseur a accepté cet écart. Le contenu ci-dessous est le texte original, non révisé.",
    "generationStopped": "La génération de cette section a été arrêtée par vous. Utilisez Réessayer pour la relancer.",
    "regenerateAllStopped": "Réessayer les sections arrêtées",
    "stopGeneration": "Arrêter la génération",
    "generateBlockedTestRunning": "Un test est en cours. Annulez-le ou attendez sa fin avant de générer le rapport.",
    "generateBlockedDataCheck": "En attente de la fin de la vérification des données avant de lancer la génération du rapport.",
    "generateBlockedSectionRetry": "Certaines sections doivent être relancées. Utilisez le bouton Réessayer de chaque section."
  },
  "dialogs": {
    "evidenceMap": {
      "title": "Examiner la carte des preuves",
      "subtitle": "Sélectionnez les fichiers qui apportent des preuves pour chaque section du rapport",
      "loading": "Chargement de la carte des preuves...",
      "noPlanSections": "Aucune section de plan à cartographier. Approuvez un plan avant de générer le rapport.",
      "noFiles": "Aucun fichier de données source trouvé. Importez des fichiers avant de générer le rapport.",
      "summary_one": "{{sections}} section sur {{files}} fichier",
      "summary_other": "{{sections}} sections sur {{files}} fichiers",
      "orphanedChip_one": "{{count}} orphelin",
      "orphanedChip_other": "{{count}} orphelins",
      "orphanWarningTitle_one": "{{count}} fichier non sélectionné pour aucune section.",
      "orphanWarningTitle_other": "{{count}} fichiers non sélectionnés pour aucune section.",
      "orphanWarningBody": "Ils seront déprioritisés lors de la récupération, et non exclus.",
      "orphanWarningInstruction": "Cliquez sur <1>Continuer quand même</1> pour générer malgré tout, ou revenez en arrière pour les cartographier d'abord.",
      "filesSelected_one": "{{selected}}/{{total}} fichier sélectionné",
      "filesSelected_other": "{{selected}}/{{total}} fichiers sélectionnés",
      "noFilesChip": "Aucun fichier",
      "selectAll": "Tous",
      "selectNone": "Aucun",
      "expandFolder": "Développer le dossier",
      "collapseFolder": "Réduire le dossier",
      "footerHint": "Ajustez les associations ci-dessous ou générez directement — les fichiers orphelins sont déprioritisés, non exclus.",
      "cancel": "Annuler",
      "confirmGenerate": "Confirmer et générer",
      "stillProceed": "Continuer quand même",
      "ariaCloseDialog": "Fermer la boîte de dialogue",
      "filesSelected": "{{count}} fichiers sélectionnés",
      "orphanWarningTitle": "Éléments orphelins",
      "orphanedChip": "Orphelin",
      "summary": "Résumé des preuves"
    },
    "fileMetadata": {
      "headerEnrich": "Enrichir vos données",
      "headerEnriching": "Enrichissement de vos données",
      "intro": "Les descriptions aident Bennie à enrichir les métadonnées et à mieux comprendre vos données. Facultatif à l'import — vous pouvez examiner et modifier les métadonnées une fois l'enrichissement terminé.",
      "placeholderStructured": "Décrivez les colonnes et les données (facultatif)...",
      "placeholderGeneric": "Description brève (facultative)...",
      "phraseAnalyzing": "Analyse de la structure du fichier...",
      "phraseExtracting": "Extraction des métadonnées clés...",
      "phraseIdentifying": "Identification des types de données...",
      "phraseMapping": "Cartographie des relations de contenu...",
      "phraseRetrieval": "Construction des indices de récupération...",
      "phraseClassifying": "Classification des matériaux sources...",
      "phraseTables": "Détection de la mise en page du contenu...",
      "phraseHeaders": "Survol du contenu du fichier...",
      "phraseSignatures": "Lecture des signatures de fichier...",
      "phraseScanning": "Recherche des sujets clés...",
      "phraseDensity": "Évaluation de la densité du contenu...",
      "phraseCrossRef": "Recoupement avec le plan...",
      "phraseProfiling": "Profilage du contenu du fichier...",
      "phraseIndexing": "Indexation des sections de contenu...",
      "phraseDescriptors": "Génération des descripteurs de recherche...",
      "phraseCatalog": "Catalogage des métadonnées sources...",
      "phraseCoverage": "Évaluation de la couverture des données...",
      "phraseRetrievalIndex": "Préparation de l'index de récupération...",
      "phraseMatching": "Mise en correspondance des fichiers et des sections...",
      "phraseAlmostThere": "On y est presque...",
      "headerEnrichmentComplete": "Enrichissement terminé",
      "headerEnrichingData": "Enrichissement de vos données",
      "completeWithReview_one": "{{enriched}} enrichi, {{review}} à examiner",
      "completeWithReview_other": "{{enriched}} enrichis, {{review}} à examiner",
      "completeNoReview_one": "{{count}} fichier enrichi avec succès",
      "completeNoReview_other": "{{count}} fichiers enrichis avec succès",
      "statusPending": "En attente",
      "statusProcessing": "Traitement",
      "statusReady": "Prêt",
      "statusNeedsReview": "Nécessite une revue",
      "statusFailed": "Non ajouté",
      "startEnrichment": "Démarrer l'enrichissement",
      "cancel": "Annuler",
      "ariaCloseDialog": "Fermer la boîte de dialogue",
      "closeTooltipRunning": "Fermer — l'enrichissement se poursuit en arrière-plan",
      "errorEnrichmentFailed": "Échec de l'enrichissement. Veuillez fermer cette boîte de dialogue et réessayer.",
      "errorEnrichmentStartFailed": "Échec du démarrage de l'enrichissement. Veuillez fermer cette boîte de dialogue et réessayer.",
      "errorEnrichmentInProgress": "L'enrichissement de cet espace de travail est déjà en cours. Veuillez fermer cette boîte de dialogue — la tâche en cours se terminera et mettra à jour la liste des fichiers automatiquement.",
      "errorEnrichmentUnexpected": "Une erreur inattendue s'est produite pendant le traitement. Veuillez fermer et réessayer.",
      "errorPollingUnstable": "Sondage d'enrichissement instable ({{count}} échecs). Nouvelle tentative en cours...",
      "errorPollingMaxFailures": "Le sondage d'enrichissement a échoué après plusieurs tentatives. Fermez et relancez l'enrichissement.",
      "statusEnriching": "Enrichissement de {{name}}... ({{done}}/{{total}})",
      "statusEnrichingMetadata": "Enrichissement des métadonnées... ({{done}}/{{total}})",
      "statusErrorEnrichment": "Erreur pendant l'enrichissement",
      "statusErrorProcessing": "Erreur pendant le traitement",
      "cancelConfirmTitle": "Annuler l'enrichissement ?",
      "cancelConfirmBody_one": "1 fichier a déjà été importé et attend l'enrichissement.",
      "cancelConfirmBody_other": "{{count}} fichiers ont déjà été importés et attendent l'enrichissement.",
      "cancelConfirmQuestion": "Que souhaitez-vous faire ?",
      "discardFiles": "Abandonner les fichiers importés",
      "discardingFiles": "Suppression des fichiers...",
      "keepForLater": "Garder pour un enrichissement ultérieur",
      "goBack": "Retour",
      "errorDiscardFailed": "Échec de la suppression d'un ou plusieurs fichiers. Veuillez réessayer.",
      "cancelConfirmBody": "Abandonner les modifications de métadonnées en cours ?",
      "completeNoReview": "Terminer sans revue",
      "completeWithReview": "Terminer avec revue"
    },
    "metadataReview": {
      "title": "Examiner les métadonnées enrichies",
      "ariaCloseDialog": "Fermer la boîte de dialogue",
      "closeTooltip": "Fermer",
      "closeTooltipRunning": "Fermer — le traitement se poursuit en arrière-plan",
      "instructionsBody": "Examinez et modifiez les métadonnées enrichies pour chaque fichier. Tous les champs sauf le nom et le type de fichier sont modifiables.",
      "ingestData": "Ingérer les données",
      "ingestInProgressTooltip": "Le traitement des données est déjà en cours.",
      "ingestNothingTooltip": "Ajoutez de nouveaux fichiers ou modifiez les métadonnées avant l'ingestion.",
      "allFilesRejectedEmpty_one": "Ce fichier n'a pas pu être ajouté ; il n'y a donc rien à examiner. Consultez la carte Source de données pour plus de détails.",
      "allFilesRejectedEmpty_other": "Ces {{count}} fichiers n'ont pas pu être ajoutés ; il n'y a donc rien à examiner. Consultez la carte Source de données pour plus de détails.",
      "cancel": "Annuler",
      "close": "Fermer",
      "ingestionFailed": "Échec du démarrage de l'ingestion des données. Veuillez fermer et réessayer.",
      "phraseIngesting": "Préparation de vos fichiers pour l'analyse...",
      "phraseExtractingText": "Extraction du contenu textuel...",
      "phraseParsing": "Analyse de la structure du fichier...",
      "phraseIndexingDocs": "Indexation des documents...",
      "phraseBuildingIndex": "Construction de l'index de recherche...",
      "phraseAnalyzingImages": "Analyse des images et OCR...",
      "phraseDataReady": "C'est prêt ! Vos données sont disponibles.",
      "phraseDataCompleteness": "Vérification de complétude des données en cours...",
      "phraseDataCoverage": "Évaluation de la couverture des données...",
      "phraseMatchingPlan": "Mise en correspondance des fichiers et des sections du plan...",
      "phaseChipETLComplete": "ETL terminé",
      "phaseChipPhase2": "Phase 2 — Indexation",
      "phaseChipPhase1Complete": "Phase 1 terminée",
      "phaseChipPhase1": "Phase 1 — Ingestion",
      "phaseChipFailed": "Échec",
      "phaseLibrarianRunning": "Cartographie des relations entre documents...",
      "phaseMappingReferences": "Chargement du contexte méthodologique...",
      "phasePromptBuilding": "Préparation de l'analyse...",
      "phaseLLMCall": "Analyse de la couverture des données...",
      "phaseParsing": "Finalisation du rapport...",
      "phaseDefault": "Évaluation de la couverture des données...",
      "headerDataReady": "Données prêtes",
      "headerDataReadyPartial": "Données prêtes — {{count}} fichier(s) n'ont pas pu être indexé(s)",
      "coverageNotSettled": "La vérification de couverture n'a pas fini de se charger. Fermez cette fenêtre et utilisez Revérifier.",
      "headerPreparing": "Préparation de vos données",
      "headerIngestFailed": "Échec de l'ingestion des données",
      "subtitleMayTake": "Cela peut prendre quelques minutes...",
      "phraseInitializing": "Initialisation...",
      "fileStatusHeader": "Statut du fichier",
      "fileStatusReady": "Prêt",
      "fileStatusFailed": "Échec",
      "fileStatusAttention": "Attention",
      "fileStatusPending": "En attente",
      "fileStatusIndexing": "Indexation",
      "fileStatusIngesting": "Ingestion",
      "ariaRetryFile": "Réessayer {{name}}",
      "tooltipRetry": "Réessayer ce fichier",
      "tooltipRetryReingest": "Relancer l'ingestion des données pour cet espace de travail",
      "timeoutTitle": "Le traitement prend plus de temps que prévu",
      "timeoutBody": "Le traitement est peut-être encore en cours. Vous pouvez vérifier à nouveau ou fermer et revenir plus tard.",
      "timeoutRetry": "Réessayer",
      "stillWorking": "Toujours en cours — cela peut prendre quelques minutes pour les fichiers volumineux ou riches en images.",
      "addTagPlaceholder": "Ajouter une étiquette...",
      "addTagButton": "Ajouter",
      "fileTypeLabel": "Type : {{type}}",
      "needsReviewChip": "Nécessite une revue",
      "errorMetadataPhase1": "Échec de l'extraction des métadonnées — saisissez la description du contenu manuellement et cliquez sur Ingérer les données, ou réimportez le fichier dans un format pris en charge (PDF, DOCX).",
      "errorPhase1NotRun": "L'extraction des métadonnées n'a pas été exécutée pour ce fichier — saisissez la description du contenu manuellement et cliquez sur Ingérer les données, ou réimportez le fichier.",
      "errorPhase2LlmFailed": "Les métadonnées n'ont pas pu être générées automatiquement — examinez les champs ci-dessous, complétez ce qui manque et cliquez sur Ingérer les données.",
      "errorVisionFailed": "Cette image n'a pas pu être décrite automatiquement — saisissez la description du contenu manuellement et cliquez sur Ingérer les données, ou réimportez l'image.",
      "errorStructuredFailed": "Ce tableur n'a pas pu être résumé automatiquement — saisissez la description du contenu manuellement et cliquez sur Ingérer les données.",
      "errorPlanMappingFailed": "Ce fichier n'a pas pu être associé automatiquement aux sections du rapport — sélectionnez ci-dessous les sections qu'il couvre et cliquez sur Ingérer les données.",
      "errorAttachmentExtractionFailed": "Les pièces jointes de cet e-mail n'ont pas pu être lues — importez-les comme fichiers distincts si le rapport en a besoin.",
      "errorImageIndexFailed": "Cette image n'a pas pu être préparée pour la recherche et n'apparaîtra pas dans les résultats du rapport — réimportez-la si le rapport en a besoin.",
      "errorEnrichmentDefault": "Enrichissement incomplet — examinez et complétez les champs manquants.",
      "fieldHeaderField": "Champ",
      "fieldHeaderValue": "Valeur",
      "showLess": "Afficher moins",
      "advanced": "Avancé",
      "fieldYes": "Oui",
      "fieldNo": "Non",
      "folderRoot": "(racine)",
      "fileRetryFailed": "Échec de la nouvelle tentative pour le fichier. Veuillez réessayer.",
      "phaseChipPhase": "Phase {{phase}}",
      "reEnrichTitle": "{{count}} fichier(s) à examiner",
      "reEnrichBody": "Leurs détails n'ont pas pu être générés automatiquement. Complétez les champs ci-dessous vous-même, ou relancez le traitement — les fichiers déjà complets ne seront pas modifiés.",
      "reEnrichButton": "Relancer le traitement",
      "reEnrichStarting": "Démarrage…",
      "reEnrichRunning": "Nouveau traitement de vos fichiers…",
      "reEnrichRunningBody": "Cela peut prendre quelques minutes. Les fichiers ci-dessous se mettent à jour au fur et à mesure.",
      "reEnrichNothing": "Il n'y avait plus rien à traiter — ces fichiers ont déjà été mis à jour.",
      "reEnrichFailed": "Le traitement n'a pas pu être démarré. Veuillez réessayer.",
      "reEnrichTimeoutTitle": "Le traitement prend plus de temps que prévu",
      "reEnrichTimeoutBody": "Il est peut-être encore en cours. Vous pouvez fermer et revenir plus tard, ou réessayer.",
      "reEnrichRecheck": "Vérifier à nouveau",
      "reEnrichUnconfirmed": "Nous n'avons pas pu confirmer si le traitement a démarré. L'état actuel est affiché ci-dessous."
    },
    "reingestConfirm": {
      "title": "Relancer l'ingestion de données ?",
      "body_one": "Cela relancera l'ingestion de données pour <1>{{count}}</1> fichier de l'espace de travail.",
      "body_other": "Cela relancera l'ingestion de données pour l'ensemble des <1>{{count}}</1> fichiers de l'espace de travail.",
      "hint": "Chaque fichier sera traité à nouveau, y compris ceux déjà terminés. La complétude sera réévaluée par la suite.",
      "phaseBody_one": "Cela relance l’ingestion de données pour <1>{{count}}</1> fichier dans la phase {{phase}}.",
      "phaseBody_other": "Cela relance l’ingestion de données pour les <1>{{count}}</1> fichiers dans la phase {{phase}}.",
      "phaseHint": "Chaque fichier de cette phase sera traité à nouveau, y compris ceux déjà terminés. La couverture de cette phase sera ensuite réévaluée.",
      "confirm": "Relancer l'ingestion",
      "confirming": "Relance en cours…"
    },
    "testConfig": {
      "headerComposing": "Composition du pipeline de test...",
      "headerExecutionPlan": "Plan d'exécution du test",
      "groupsIdentified_one": "{{count}} groupe de test identifié",
      "groupsIdentified_other": "{{count}} groupes de test identifiés",
      "stage1Title": "Analyse des sections du plan et mise en correspondance avec les outils...",
      "stage1Body": "Recherche des outils disponibles, lecture des procédures de test et regroupement des sections du plan en groupes de tests.",
      "stage2Title": "Préparation du pipeline{{suffix}}",
      "stage2TitleSuffix": " pour le groupe {{progress}}",
      "stage2TitleSuffixDefault": "...",
      "stage2Body": "Récupération des définitions d'outils, composition du code du pipeline et validation des données requises pour chaque groupe de test.",
      "stage2GroupCaption": "Groupe {{progress}}",
      "errorTitle": "Échec de la composition du plan de test",
      "errorWhatThisMeans": "<1>Ce que cela signifie :</1> un plan de test exécutable n’a pas pu être produit pour cet espace de travail. Réessayez, et contactez le support si le problème persiste.",
      "errorNextStep": "<1>Étape suivante :</1> cliquez sur « Réessayer » ci-dessous. Si l’échec se reproduit, contactez le support en indiquant le nom de l’espace de travail et l’heure de l’incident.",
      "errorCompositionId": "composition_id : {{id}}",
      "compositionFailedDefault": "Échec de la composition du plan de test.",
      "noActionableResult": "Aucun groupe de tests n’a pu être produit pour cet espace de travail. Réessayez, ou contactez le support si le problème persiste.",
      "compositionFailedTemplate": "Échec de la composition du plan de test : {{error}}",
      "compositionDoneNoGroups": "La composition est terminée mais aucun groupe de test n'a été retourné.",
      "executionFailedTemplate": "Échec de l'exécution du test : {{error}}",
      "partialFailureTitle_one": "Composition partielle : {{count}} groupe n'a pas pu être préparé",
      "partialFailureTitle_other": "Composition partielle : {{count}} groupes n'ont pas pu être préparés",
      "partialFailureNote": "Vous pouvez continuer avec les groupes composés avec succès ou relancer la composition.",
      "coversSectionsLabel": "Couvre les sections du plan :",
      "dataRequirementsHeader": "Données d'entrée requises :",
      "pipelineCodeLabel": "Code du pipeline :",
      "pipelineExpand": "Développer / Modifier",
      "pipelineCollapse": "Réduire",
      "uploadHeaderMulti": "Importer les données de test (un fichier par groupe)",
      "uploadHintMulti": "Chaque groupe de test peut nécessiter une forme de données différente. Importez le fichier dont le schéma correspond aux données requises de chaque groupe. CSV, XLSX ou Parquet.",
      "uploadSelectedLabel": "Sélectionné : {{name}} ({{size}} ko)",
      "uploadCoversShort": "couvre : {{names}}{{ellipsis}}",
      "uploadChooseFileFor": "choisir un fichier pour ce groupe",
      "uploadReplace": "Remplacer",
      "uploadChooseFile": "Choisir un fichier",
      "uploadHeaderSingle": "Importer les données de test (CSV, XLSX ou Parquet)",
      "uploadSizeKb": "{{size}} ko",
      "uploadHintSingle": "Cliquez pour parcourir ou faites glisser-déposer le jeu de données de test",
      "footerSummaryGroups": "{{uploaded}}/{{total}} groupes ont des données sélectionnées",
      "footerSummaryFile": "Données : {{name}}",
      "footerSummaryUpload": "Importez les données de test pour continuer",
      "footerTestsReady_one": "{{count}} test prêt | {{status}}",
      "footerTestsReady_other": "{{count}} tests prêts | {{status}}",
      "running": "Exécution...",
      "runTests_one": "Lancer {{count}} test",
      "runTests_other": "Lancer {{count}} tests",
      "cancel": "Annuler",
      "retry": "Réessayer",
      "kernelLabel": "Moteur d'exécution : {{phase}}",
      "kernelGroupsCompleted": "{{passed}} / {{total}} groupes terminés",
      "kernelSpawning": "Démarrage du moteur d'exécution...",
      "kernelReady": "Moteur d'exécution prêt — exécution des groupes de test...",
      "kernelExecuting": "Exécution des groupes de test sur le moteur d'exécution...",
      "kernelInProgress": "Exécution des tests en cours...",
      "executionFailedAlert": "L'exécution du test a échoué ou a expiré. Vous pouvez fermer cette boîte de dialogue et réessayer.",
      "footerTestsReady": "{{count}} tests prêts",
      "groupsIdentified": "{{count}} groupes identifiés",
      "partialFailureTitle": "Échec partiel",
      "runTests": "Lancer les tests",
      "stage": "Étape"
    },
    "testResults": {
      "title": "Résultats de l'exécution de test",
      "subtitle": "Examinez et approuvez les artefacts avant de générer le rapport",
      "allApprovedTitle": "Tous les tests approuvés !",
      "allApprovedBody": "Les artefacts de test ont été indexés et sont prêts pour la génération du rapport.",
      "downloadCsv": "Télécharger le CSV",
      "generateReport": "Générer le rapport",
      "noArtifactsTitle": "Aucun artefact à afficher",
      "executionInProgressTitle": "Exécution du test en cours...",
      "executionInProgressBody": "Les résultats apparaîtront ici une fois l'exécution terminée.",
      "noArtifactsBody": "Les résultats des outils ont été catalogués comme fichiers de données sources et sont prêts pour la génération du rapport.",
      "submitApprovals": "Envoyer les approbations",
      "submitting": "Envoi...",
      "cancel": "Annuler",
      "submitFailed": "Échec de l'envoi des approbations. Veuillez réessayer.",
      "passLabel": "RÉUSSI",
      "failLabel": "ÉCHEC",
      "untitledArtifact": "Outil {{n}}",
      "kernelArtifactDefault": "Artefact d'exécution",
      "errorLabel": "Erreur",
      "noStructuredOutput": "Exécution terminée — aucune sortie structurée.",
      "resultTooLarge": "Données de résultat trop volumineuses pour être affichées en ligne. Utilisez Télécharger le CSV pour la sortie complète.",
      "flaggedCells_one": "{{count}} cellule signalée",
      "flaggedCells_other": "{{count}} cellules signalées",
      "sectionLabelDefault": "Section {{n}}",
      "unexplainedPercent": "{{value}} % inexpliqués",
      "triggered": "Déclenché",
      "ok": "OK",
      "emptyText": "(vide)",
      "flaggedCells": "Cellules signalées"
    }
  },
  "issueLog": {
    "panelTitle": "Journal des problèmes",
    "ariaLabel": "Journal des problèmes",
    "exportCsv": "Exporter en CSV",
    "exporting": "Export en cours…",
    "exportTooltip": "Télécharger le CSV (ignore le filtre de gravité actuel)",
    "scopeUnattributed_one": "{{count}} problème de cette analyse n'est lié à aucun élément du plan et n'est pas affiché ici.",
    "scopeUnattributed_other": "{{count}} problèmes de cette analyse ne sont liés à aucun élément du plan et ne sont pas affichés ici.",
    "csvExportFailed": "Échec de l'export CSV",
    "ariaCollapse": "Réduire le journal des problèmes",
    "ariaExpand": "Développer le journal des problèmes",
    "loadingIssueLog": "Chargement du journal des problèmes…",
    "updating": "Mise à jour…",
    "retry": "Réessayer",
    "tableHeaderSeverity": "Gravité",
    "tableHeaderFinding": "Observation",
    "tableHeaderSection": "Section",
    "tableHeaderGoTo": "Aller à",
    "tableHeaderDetails": "Détails",
    "noMatching": "Aucun problème ne correspond au filtre de gravité actuel.",
    "noIssues": "Aucun problème.",
    "details": "Détails",
    "ariaJumpToSection": "Aller à l’élément source {{id}}",
    "navigationUnavailable": "L’élément source est indisponible.",
    "tooltipJumpToSection": "Ouvrir l’élément source.",
    "stateLabelPreGate": "Le journal des problèmes se remplira après la fin de l'auto-vérification du rapport.",
    "stateLabelPopulating": "Préparation du journal des problèmes…",
    "stateLabelAggregating": "Synthèse des problèmes de cause racine…",
    "stateLabelEmpty": "Aucun problème identifié.",
    "stateLabelDrift": "Journal des problèmes rempli, dérive d'attribution signalée.",
    "stateLabelExtractionPaused": "Extraction des problèmes en pause — le journal reprendra à la prochaine exécution.",
    "stateLabelPopulated_one": "{{count}} problème synthétisé.",
    "stateLabelPopulated_other": "{{count}} problèmes synthétisés.",
    "sortChip": "Tri : Gravité {{direction}}",
    "severityRollup": "{{count}} Type {{tier}}",
    "stateLabelPopulated": "Renseigné",
    "supportsValidation": {
      "none_emitted": "Ce problème est une observation transversale, sans symptômes à l’appui rattachés.",
      "partial_invalid": "Certaines références de symptômes à l’appui n’ont pas pu être résolues.",
      "none_valid": "Aucune des références de symptômes à l’appui n’a pu être résolue ; les symptômes de ce problème ne peuvent donc pas être affichés."
    },
    "relatedIssuesLabel": "S'appuie sur :",
    "relatedIssueUnresolved": "un problème absent de ce journal",
    "stateLabelFailed": "La compilation du journal des problèmes a échoué. Réessayez ou continuez sans.",
    "stateLabelVersionFailed": "La dernière version du rapport n'a pas pu être terminée ; il n'y a donc pas de journal des problèmes pour elle. Utilisez « Générer une nouvelle version ».",
    "stateLabelSkipped": "Aucun journal des problèmes — ce rapport a été compilé sans.",
    "retryAggregation": "Réessayer la compilation",
    "skipAggregation": "Continuer sans journal des problèmes",
    "tableHeaderFindingId": "ID",
    "tableHeaderStatus": "Statut",
    "tableHeaderModelLog": "Journal du modèle",
    "statusReadOnlyExplainer": "Le statut est en lecture seule ici. Définissez-le dans le journal des problèmes du modèle.",
    "statusOpen": "Ouvert",
    "sectionNone": "Aucune section",
    "openInModelLog": "Ajouter cette observation au journal des problèmes du modèle",
    "openInModelLogNoModel": "Ce projet n'est pas encore rattaché à un modèle : il n'y a donc aucun journal de modèle auquel l'ajouter.",
    "openInModelLogUnavailable": "L’ajout d’une observation au journal des problèmes du modèle n’est pas encore disponible.",
    "loadFailed": "Le journal des problèmes n'a pas pu être chargé. Veuillez réessayer.",
    "stateLabelLoadFailed": "Journal des problèmes indisponible — le chargement a échoué.",
    "stateLabelUnknown": "Le journal des problèmes est dans un état inattendu et peut donc être incomplet. Veuillez réessayer ou contacter le support.",
    "openInModelLogNoFindingUid": "Cette observation n’a pas de référence partagée : elle ne peut donc pas être ajoutée au journal des problèmes du modèle.",
    "escalateFailed": "Cette observation n’a pas pu être ajoutée au journal des problèmes du modèle. Veuillez réessayer.",
    "openInModelLogAlreadyAdded": "Déjà présente dans le journal des problèmes du modèle.",
    "escalateConfirmTitle": "Ajoutée au journal des problèmes du modèle",
    "escalateConfirmBody": "{{issueId}} figure désormais dans le journal des problèmes du modèle.",
    "escalateConfirmDismiss": "Fermer"
  },
  "softWarnings": {
    "ariaLabel": "Avertissements légers à l'export",
    "title_one": "Le dernier export a émis {{count}} avertissement léger",
    "title_other": "Le dernier export a émis {{count}} avertissements légers",
    "intro": "L'export s'est terminé avec succès, mais le moteur de rendu du document a signalé les problèmes suivants. Le fichier est téléchargeable ; les prochains exports réévalueront ces signaux.",
    "sectionLabel": "Section {{id}} :",
    "sectionLabelTitled": "{{title}} :",
    "kinds": {
      "pandoc_stderr": "Le moteur de rendu du document a signalé un problème dans cette section.",
      "image_embed_failed": "Une image de cette section n'a pas pu être incluse dans l'export.",
      "generic": "Le moteur de rendu du document a signalé un problème."
    },
    "truncated": "+{{count}} avertissements supplémentaires non affichés"
  },
  "templateStyle": {
    "titlePartial": "Style du modèle partiellement préservé",
    "titleFailed": "Échec de la préservation du style du modèle",
    "ariaWarning": "Avertissement sur la préservation du style du modèle",
    "bodyPartialPrefix": "{{warning}} Les polices et l'espacement de votre modèle seront tout de même appliqués au rapport exporté — la page de garde et le placement des sections utiliseront les valeurs par défaut.",
    "bodyPartialDefault": "La structure du modèle n'a pas pu être préservée.",
    "bodyFailedPrefix": "{{warning}} Aucun effet sur la génération du contenu.",
    "bodyFailedDefault": "Un style générique sera appliqué à l'export."
  },
  "sectionsTab": {
    "outputTemplateTitle": "Modèle de sortie",
    "outputTemplateOptional": "(facultatif)",
    "outputTemplateHelp": "Importez un fichier modèle pour structurer et styliser le rapport.",
    "uploadOutputTemplateLabel": "Importer le modèle de sortie",
    "modelDevelopmentReportTitle": "Rapport de développement du modèle",
    "mdrInheritedHelp": "Les fichiers sources de cet espace de travail incluent le dernier rapport de développement de son modèle parent, qu’il soit approuvé ou en attente d’approbation.",
    "mdrInheritedLoading": "Vérification du rapport de développement du modèle dont hérite cet espace de travail…",
    "mdrInheritedUnreadable": "Le rapport de développement du modèle hérité n’a pas pu être lu à l’instant ; cet espace de travail ne peut donc pas indiquer ce qu’il hérite.",
    "mdrInheritedNoneApproved": "Aucun rapport de développement du modèle n'est en vigueur pour cet espace de travail. Son modèle parent n'a aucune version approuvée ni en attente ; la génération du plan s'exécutera donc sans rapport.",
    "mdrInheritedPendingApproval": "Le modèle parent de cet espace de travail a un rapport de développement en attente d'approbation. La génération du plan utilise la dernière version comme référence provisoire non approuvée.",
    "mdrInheritedNotModelRooted": "Cet espace de travail a été créé avant que les espaces de travail ne soient rattachés à un modèle : il n'a donc aucun modèle parent dont hériter un rapport de développement. La génération du plan s'exécute sans rapport.",
    "mdrInheritedVersionMeta": "Version {{versionId}} · importée le {{uploadedAt}}",
    "mdrInheritedOpenModel": "Ouvrir le rapport de développement du modèle",
    "uploadTaskDescriptionLabel": "Importer la description de tâche",
    "taskDescriptionTitle": "Description de la tâche",
    "taskDescriptionHelp": "Importez un fichier markdown ou un document décrivant le périmètre des travaux.",
    "taskDescriptionHelp_validation": "Importez un fichier markdown ou un document décrivant le périmètre de validation.",
    "taskDescriptionHelp_auditing": "Importez un fichier markdown ou un document décrivant le périmètre de l'audit.",
    "taskDescriptionHelp_development": "Importez un fichier markdown ou un document décrivant le périmètre du développement.",
    "sectionPhase": {
      "extractingSymptoms": "Extraction des symptômes...",
      "aggregatingIssues": "Agrégation des problèmes...",
      "holisticValidating": "Auto-vérification globale...",
      "execSumGenerating": "Génération du résumé exécutif..."
    },
    "sectionStatus": {
      "pending": "En attente",
      "in_progress": "En cours",
      "context_ready": "Contexte prêt",
      "context_unavailable": "Contexte indisponible",
      "generating": "Génération",
      "generated": "Généré",
      "pending_validation": "Auto-vérification en attente",
      "validating": "En cours d'auto-vérification",
      "validation_skipped": "Auto-vérification ignorée",
      "validated": "Auto-vérifié",
      "approved": "Approuvé",
      "user_accepted_as_gap": "Accepté comme lacune",
      "needs_regen": "Régénération nécessaire",
      "failed": "Échec",
      "generation_failed": "Échec de la génération",
      "pending_phase_2c": "En attente",
      "generation_stopped": "Arrêtée"
    }
  },
  "markComplete": {
    "button": {
      "label": "Marquer comme terminé"
    },
    "modal": {
      "title": "Marquer l'espace de travail comme terminé ?",
      "body": "Marquer l'espace de travail comme terminé verrouillera toutes les actions de modification. Ne procédez ainsi que pour figer le contexte de l'espace de travail à des fins d'audit ultérieur. Confirmez-vous l'opération ?",
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "success": "Espace de travail marqué comme terminé.",
      "alreadyComplete": "L'espace de travail est déjà marqué comme terminé."
    }
  },
  "reportPreview": {
    "versionPagerMismatch": "La version v{{currentVersion}} n’est plus disponible pour cette section. Essayez d’actualiser la section."
  },
  "dataPanel": {
    "ineligibility": {
      "archived": "Ce projet est archivé ; il ne peut plus recevoir de données sources.",
      "model_archived": "Le modèle auquel appartient ce projet est archivé ; ce projet ne peut plus recevoir de données sources.",
      "no_workflow_state": "Ce projet n’a pas encore été configuré ; il n’y a nulle part où placer des données sources.",
      "report_generation_started": "La génération du rapport a commencé ; ce projet n’accepte plus de nouvelles données sources.",
      "workspace_terminal": "Ce projet est terminé ; il ne peut plus recevoir de nouvelles données sources.",
      "failed_state": "Résolvez d’abord l’étape en échec de ce projet, puis ajoutez des données sources.",
      "workspace_busy": "Ce projet est occupé — attendez la fin de l’étape en cours, puis ajoutez des données sources.",
      "workspace_busy_before_plan": "Vous pourrez ajouter des données sources une fois le plan approuvé.",
      "default": "Ce projet ne peut pas recevoir de nouvelles données sources pour le moment."
    },
    "unavailable": "Impossible de vérifier ce que vous pouvez faire avec les données de ce projet. Actualisez pour réessayer."
  },
  "exportVersion": {
    "label": "Version à exporter",
    "none": "Sélectionnez une version"
  },
  "reportVersions": {
    "busy": "Un rapport est en cours de génération. Une nouvelle version pourra être lancée à la fin.",
    "collectionNotSettled": "Une nouvelle version pourra être lancée une fois le traitement de vos fichiers terminé.",
    "filesChanged": "Les fichiers de référence ont changé depuis le rapport V{{version}} : {{added}} ajouté(s), {{removed}} retiré(s). Générez une nouvelle version pour inclure ces changements.",
    "rejectedFilesNotice_one": "{{count}} fichier n'a pas été ingéré, car son format n'est pas pris en charge ; le rapport V{{version}} a donc été généré sans lui. Téléversez des exportations CSV ou JSON de ces données pour les inclure dans une nouvelle version.",
    "rejectedFilesNotice_other": "{{count}} fichiers n'ont pas été ingérés, car leur format n'est pas pris en charge ; le rapport V{{version}} a donc été généré sans eux. Téléversez des exportations CSV ou JSON de ces données pour les inclure dans une nouvelle version.",
    "failed": {
      "report_generation_cancelled": "Cette version a été arrêtée avant la fin. La version précédente est inchangée. Générez une nouvelle version.",
      "report_generation_cancelled_first": "Cette version a été arrêtée avant la fin. Générez une nouvelle version.",
      "generic": "Cette version n’a pas pu être générée. La version précédente est inchangée. Générez une nouvelle version.",
      "generic_first": "Cette version n’a pas pu être générée. Générez une nouvelle version.",
      "halted": "Cette version s’est arrêtée car la génération est suspendue par un problème en amont. La version précédente est inchangée. Utilisez « {{clearHalt}} » pour reprendre, puis générez une nouvelle version.",
      "halted_first": "Cette version s’est arrêtée car la génération est suspendue par un problème en amont. Utilisez « {{clearHalt}} » pour reprendre, puis générez une nouvelle version."
    }
  }
}
